import { del, get, post, put, patch } from "./api_helper"
import * as url from "./url_helper"

// Login Method
const login = data => post(url.LOGIN, data)
const getAuthProfile = () => get(url.AUTH_PROFILE)
const postLogout = () => post(url.AUTH_LOGOUT, {})
const postChangePassword = data => post(url.CHANGE_PASSWORD, data)

// Register Methods
const verifyEmail = data => post(url.VERIFY_EMAIL, data)
const verifySessionCode = data => post(url.VERIFY_CODE, data)
const setPassword = data => post(url.SET_PASSWORD, data)

// Reset Password Methods
const verifyResetEmail = data => post(url.VERIFY_RESET_EMAIL, data)
const verifyResetSessionCode = data => post(url.VERIFY_RESET_CODE, data)
const setResetPassword = data => post(url.SET_RESET_PASSWORD, data)
const setPasswordWithToken = data => post(url.SET_PASSWORD_WITH_TOKEN, data)
const sendAdminPasswordResetLink = userId =>
  post(`${url.USERS}/${userId}/password-reset-link`, {})

// Users Methods
const users = (params = {}) => {
  return get(`${url.USERS}`, { params })
}
const createUserData = data => post(url.USERS, data)
const updateUserData = ({ userId, data }) => patch(`${url.USERS}/${userId}`, data)
const deleteUserData = id => del(`${url.USERS}/${id}`)
const getUserData = (userId) => get(`${url.USERS}/${userId}`)
const fetchDomainsApi = () => get(url.GET_DOMAINS)

// Blacklist Methods
const getBlacklist = (params) => get(url.BLACKLIST, { params });
const addBlacklistEntry = (data) => post(url.BLACKLIST, data);
const deleteBlacklistEntry = (id) => del(`${url.BLACKLIST}/${id}`);

// Distributor Whitelist Methods
const getDistributorWhitelist = (params) => get(url.DISTRIBUTOR_WHITELIST, { params });
const addDistributorWhitelistEntry = (data) => post(url.DISTRIBUTOR_WHITELIST, data);
const deleteDistributorWhitelistEntry = (id) => del(`${url.DISTRIBUTOR_WHITELIST}/${id}`);

// Compenies Methods
const companies = (params = {}) => get(`${url.COMPANIES}`, { params })
const createCompanyData = data => post(url.COMPANIES, data)
const getCompanyData = id => get(`${url.COMPANIES}/${id}`)
const updateCompanyData = ({ companyId, data }) => patch(`${url.COMPANIES}/${companyId}`, data)
const deleteCompanyData = id => del(`${url.COMPANIES}/${id}`)

// Documents Methods
const documents = (params = {}) => get(url.ADMIN_DOCUMENTS, { params })
const createDocumentData = data => post(url.ADMIN_DOCUMENTS, data)
const getDocumentData = id => get(`${url.ADMIN_DOCUMENT}/${id}`)
const updateDocumentData = ({ id, data }) => patch(`${url.ADMIN_DOCUMENT}/${id}`, data)
const deleteDocumentData = id => del(`${url.ADMIN_DOCUMENT}/${id}`)
const companyDocuments = (companyId, params = {}) =>
  get(`${url.COMPANY_DOCUMENTS}/${companyId}/documents`, { params })
const myDocuments = (params = {}) => get(url.ME_DOCUMENTS, { params })
const assignCompaniesToDocument = (id, companyIds = []) =>
  post(`${url.ASSIGN_DOCUMENT_COMPANIES}/${id}/assign-companies`, { companyIds })

// helpers/backend-helper.js

// ADMIN Dashboard
const fetchAdminData = (params = {}) =>
  get(url.GET_DASHBOARD_DATA, { params });

const fetchAdminSignups = (weeks = 12, params = {}) =>
  get(url.GET_DASHBOARD_SIGNUPS, { params: { weeks, ...params } });

const fetchAdminDocumentsMonthly = (year, params = {}) =>
  get(url.GET_DASHBOARD_DOCUMENTS_MONTHLY, { params: { year, ...params } });

const fetchAdminCompanyTypes = (params = {}) =>
  get(url.GET_DASHBOARD_COMPANY_TYPES, { params });

const fetchAdminActiveSessions = (interval = 20, params = {}) =>
  get(url.GET_DASHBOARD_DAILY_DOCUMENTS, { params: { interval, ...params } });

// ME Dashboard
const fetchMeDashboardSummary = (params = {}) =>
  get(url.GET_ME_DASHBOARD_SUMMARY, { params });

const fetchMeDashboardDailyDocs = (params = {}) =>
  get(url.GET_ME_DASHBOARD_DAILY_DOCS, { params });

const fetchMeDashboardDocsMonthly = (year, params = {}) =>
  get(url.GET_ME_DASHBOARD_DOCS_MONTHLY, { params: { year, ...params } });

const fetchMeDashboardTopTypes = (params = {}) =>
  get(url.GET_ME_DASHBOARD_TOP_TYPES, { params });

// Assessment Methods
const assessments = () => get(url.GET_ASSESSMENTS)

const addAssessment = data => post(url.ADD_ASSESSMENT, data)

const updateAssessmentData = data =>
  put(`${url.ASSESSMENT}/${data.id}`, data.payload)

const deleteAssessments = id => del(`${url.ASSESSMENT}/${id}`)

// Resident Assessment Methods

const residentAssessments = () => get(url.GET_RESIDENT_ASSESSMENTS)

const addResidentAssessmentData = data =>
  post(url.ADD_RESIDENT_ASSESSMENT, data)

const updateResidentAssessmentData = data =>
  put(`${url.RESIDENT_ASSESSMENT}/${data.id}`, data.payload)

// Pch Assessment Methods

const pchAssessments = () => get(url.PCH_ASSESSMENTS)
const addPchAssessmentData = data => post(url.PCH_ASSESSMENTS, data)
const updatePchAssessmentData = data =>
  put(`${url.PCH_ASSESSMENTS}/${data.id}`, data.payload)
const deletePchAssessmentData = id => del(`${url.PCH_ASSESSMENTS}/${id}`)
const clonePchAssessmentData = id => post(`${url.CLONE_ASSESSMENT}/${id}`)
const clonePchCarePlan = id => post(`${url.CLONE_CAREPLAN}/${id}`)

// PATIENTS

const createNewPatient = data => post(url.ADD_NEW_PATIENT, data)
const getPatientsData = () => get(url.GET_PATIENTS)
const updatePatients = data => put(`${url.UPDATE_PATIENT}/${data.id}`, data)
const deletePatients = id => del(`${url.DELETE_PATIENT}/${id}`)

export {
  login,
  getAuthProfile,
  postLogout,
  postChangePassword,
  verifyEmail,
  verifySessionCode,
  setPassword,
  verifyResetEmail,
  verifyResetSessionCode,
  setResetPassword,
  setPasswordWithToken,
  sendAdminPasswordResetLink,
  users,
  createUserData,
  updateUserData,
  deleteUserData,
  getUserData,
  getBlacklist,
  addBlacklistEntry,
  deleteBlacklistEntry,
  getDistributorWhitelist,
  addDistributorWhitelistEntry,
  deleteDistributorWhitelistEntry,
  companies,
  fetchDomainsApi,
  createCompanyData,
  getCompanyData,
  updateCompanyData,
  deleteCompanyData,
  documents,
  createDocumentData,
  updateDocumentData,
  getDocumentData,
  deleteDocumentData,
  companyDocuments,
  myDocuments,
  fetchAdminData,
  fetchAdminSignups,
  fetchAdminDocumentsMonthly,
  fetchAdminCompanyTypes,
  fetchAdminActiveSessions,
  fetchMeDashboardDailyDocs,
  fetchMeDashboardSummary,
  fetchMeDashboardTopTypes,
  fetchMeDashboardDocsMonthly,
  assignCompaniesToDocument,
  assessments,
  addAssessment,
  updateAssessmentData,
  deleteAssessments,
  residentAssessments,
  addResidentAssessmentData,
  updateResidentAssessmentData,
  pchAssessments,
  addPchAssessmentData,
  updatePchAssessmentData,
  deletePchAssessmentData,
  clonePchAssessmentData,
  clonePchCarePlan,
  getPatientsData,
  createNewPatient,
  updatePatients,
  deletePatients,
}
